import { render, staticRenderFns } from "./MatterList.vue?vue&type=template&id=63f18ed7&scoped=true"
import script from "./MatterList.vue?vue&type=script&lang=js"
export * from "./MatterList.vue?vue&type=script&lang=js"
import style0 from "./MatterList.vue?vue&type=style&index=0&id=63f18ed7&prod&lang=scss"
import style1 from "./MatterList.vue?vue&type=style&index=1&id=63f18ed7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f18ed7",
  null
  
)

export default component.exports